import React, {useState, useEffect, useRef} from 'react'
import './CadreJeu.scss'
import TexteHaut from './TexteHaut'
import CardGrid from './CardGrid'
import AfficherPartiePerdu from './AfficherPartiePerdu'
import AfficherPartieGagne from './AfficherPartieGagne'


export default function CadreJeu() {
    const TIME = 45
    const NB_CARTES = 6

    const [niveau, setNiveau] = useState(1)
    const [partieGagne, setPartieGagne] = useState(false)
    const [partiePerdu, setPartiePerdu] = useState(false)
    const [nbCartes, setNbCartes] = useState(NB_CARTES)
    const [score, setScore] = useState(90)
    const [timer, setTimer] = useState(TIME)
    const [tabRobots, setTabRobots] = useState([])
    
    const [newGame, setNewGame] = useState(false)

    const timeRef = useRef(null)

    // initialise le plateau de cartes aléatoirement en paires de robots
    const initialiserTabRobots = () => {
       
        

        // utiliser modulo (nbCartes/2) pour avoir des paires de chiffres dans le tableau de robots (ex: [2,3,1,2,3,1] pour 6 cartes sur le plateau) 
            // 1%3 = 1 + 1 = 2
            // 2%3 = 2 + 1 = 3
            // 3%3 = 0 + 1 = 1
            // 4%3 = 1 + 1 = 2
            // 5%3 = 2 + 1 = 3
            // 6%3 = 0 + 1 = 1

        console.log(nbCartes)

        const nbPaires = nbCartes / 2
        const newTabRobots = []

        for (let i = 1; i <= nbCartes; i++) {
            
            newTabRobots.push((i % nbPaires) + 1)

        }

        setTabRobots(randomize(newTabRobots))

        setNewGame(false)

    }

    const calculerNbCartesSelonNiveau = () => {
        if (niveau === 1) setNbCartes(6)
        if (niveau === 2 || niveau === 3) setNbCartes(8)
        if (niveau >= 4) setNbCartes(12)
    }
    

    // mélanger un tableau selon algorithme de Fisher
    function randomize(tab) {
        let i, j, tmp;
        for (i = tab.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            tmp = tab[i];
            tab[i] = tab[j];
            tab[j] = tmp;
        }
        return tab;
    }

    const reinitialiserJeu = () => {
        setNiveau(1)
        setPartiePerdu(false)
        setNbCartes(NB_CARTES)
        setScore(90)
        setTimer(TIME)
        setNewGame(true)
    }

    const niveauSuivant = () => {
        setNiveau(niveau + 1)
        setPartieGagne(false)
        // setNbCartes(prevState => prevState + 2)

        calculerNbCartesSelonNiveau()

        setScore(score + 60)
        setTimer(TIME)
    }

    const nbCartesRestantes = (n) => {
        setNbCartes(c => c + n)
    }

    const changeScore = (chiffre) => {
        setScore(score + chiffre)
    }

    const changeTimer = () => {

        clearInterval(timeRef.current)

        const timerInterval = setInterval(() => {
            setTimer(prevTimer => prevTimer - 1)
            
        }, 1000)

        timeRef.current = timerInterval

    }

    const checkTimer = () => {
        
        if (timer <= 0) {
            clearInterval(timeRef.current)
            setPartiePerdu(true)
        }
        else if (nbCartes <= 0) {
            clearInterval(timeRef.current)
            setTimeout(() => {
                setPartieGagne(true)
            }, 600)
        }
    }


    useEffect(() => {

        checkTimer()

    })

    // initialise le tableau de robots lors du 1er rendu du composant 
    // et lorsqu'on clique sur rejouer ou que l'on passe au niveau suivant
    useEffect(() => {

        // calculerNbCartesSelonNiveau()
        initialiserTabRobots()

    }, [newGame, niveau])
    

    return (
        <div className={`cadreJeu ${niveau > 2 ? 'background2' : null} ${partiePerdu ? 'partiePerdu' : null}`}>
            <TexteHaut score={score} timer={timer} niveau={niveau} />

            {partiePerdu ? <AfficherPartiePerdu 
                            score={score} 
                            reinitialiserJeu={reinitialiserJeu} />
                : partieGagne ? <AfficherPartieGagne 
                                score={score} 
                                niveauSuivant={niveauSuivant} />
                    : <CardGrid 
                        changeScore={changeScore} 
                        changeTimer={changeTimer} 
                        nbCartesRestantes={nbCartesRestantes}
                        tabRobots={tabRobots}
                        niveau={niveau} />
            }

        </div>
    )
}
